import React, { useState, useEffect } from "react";
import axios from "axios";
import ResultReport from "./ResultsReport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSave, faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
import { exportToExcel } from "../export/exportToExcel";
import { exportToPdf } from "../export/exportToPdf";
import { exportToWord } from "../export/exportToWord";
import { exportToPrint } from "../export/exportToPrint";

const MainReport = () => {
  const [showResult, setShowResult] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [classSectionData, setClassSectionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  useEffect(() => {
    const handlePopState = () => setShowResult(false);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

useEffect(() => {
  const fetchData = async () => {
    const userRole = localStorage.getItem("userRole");
    if (!userRole) {
      console.warn("No userRole found in localStorage. Please log in.");
      return;
    }

    try {
      setLoading(true);
      const classRes = await axios.get("https://aadyaacademy.org/api/classes-sections");
      if (Array.isArray(classRes.data.data)) {
        setClassSectionData(classRes.data.data);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setClassSectionData([]);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);


  const handleViewClick = (cls, sec) => {
    setSelectedClass(cls);
    setSelectedSection(sec);
    setShowResult(true);
    window.history.pushState({}, "", "");
  };

  const handleBackClick = () => {
    setShowResult(false);
    setSelectedClass("");
    setSelectedSection("");
    setSearchTerm("");
  };

  const handleSave = (cls, sec) => {
    alert(`Saved result report for Class ${cls} - Section ${sec}`);
  };

  const handleDownload = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const downloadAs = async (format, cls, sec) => {
    const fileName = `Unit_Test_Report_${cls}_${sec}`;
    try {
      setLoading(true);
      const res = await axios.get(
        `https://aadyaacademy.org/api/student-reports?className=${cls}&section=${sec}` // Fixed § to &
      );
      const studentRecords = Array.isArray(res.data?.data) ? res.data.data : [];

      if (!studentRecords.length) {
        alert("No student records found.");
        return;
      }

      if (format === "excel") exportToExcel(studentRecords, fileName);
      else if (format === "pdf") await exportToPdf(studentRecords, fileName);
      else if (format === "word") await exportToWord(studentRecords, fileName);
      else if (format === "print") exportToPrint(studentRecords, cls, sec);
    } catch (err) {
      console.error("Download error:", err);
      alert("Failed to fetch student data for export.");
    } finally {
      setOpenDropdownIndex(null);
      setLoading(false);
    }
  };

  const getAllClasses = () => [...new Set(classSectionData.map((item) => item.class))];
  const getAllSections = () => [...new Set(classSectionData.flatMap((item) => item.sections))];

  const filteredResults = [];
  classSectionData.forEach((clsObj) => {
    const clsName = clsObj.class;
    clsObj.sections.forEach((sec) => {
      const matchSearch =
        clsName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sec.toLowerCase().includes(searchTerm.toLowerCase());
      const matchClass = selectedClass === "" || selectedClass === clsName;
      const matchSection = selectedSection === "" || selectedSection === sec;
      if (matchSearch && matchClass && matchSection) {
        filteredResults.push({ class: clsName, section: sec });
      }
    });
  });

  if (showResult) {
    return (
      <ResultReport
        selectedClass={selectedClass}
        selectedSection={selectedSection}
        onBack={handleBackClick}
      />
    );
  }

  const buttonStyle = {
    backgroundColor: "#e0e0e0",
    border: "none",
    borderRadius: "8px",
    padding: "8px 10px",
    fontSize: "12px",
    cursor: "pointer",
  };

  const dropdownItemStyle = {
    padding: "6px 10px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    fontSize: "12px",
    backgroundColor: "#fff",
  };

  return (
    <div className="assignment-report" style={{ fontSize: "13px" }}>
      <div className="table-header" style={{ marginBottom: "10px" }}>
        <h3 style={{ fontSize: "16px" }}>Results Report</h3>
        <div className="table-header-btm" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="Search by class or section"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ fontSize: "12px", padding: "6px", borderRadius: "5px", border: "1px solid #ccc" }}
          />
          <select
            className="class-filter"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            style={{ fontSize: "12px", padding: "6px", borderRadius: "5px" }}
          >
            <option value="">All Classes</option>
            {getAllClasses().map((cls, i) => (
              <option key={i} value={cls}>
                {cls}
              </option>
            ))}
          </select>
          <select
            className="section-filter"
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
            style={{ fontSize: "12px", padding: "6px", borderRadius: "5px" }}
          >
            <option value="">All Sections</option>
            {getAllSections().map((sec, i) => (
              <option key={i} value={sec}>
                {sec}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <p style={{ fontSize: "12px" }}>Loading...</p>
      ) : (
        <table style={{ fontSize: "12px", width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Class</th>
              <th>Section</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredResults.length > 0 ? (
              filteredResults.map((item, index) => (
                <tr key={index}>
                  <td>{item.class}</td>
                  <td>{item.section}</td>
                  <td style={{ position: "relative" }}>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      <button
                        onClick={() => handleViewClick(item.class, item.section)}
                        title="View"
                        style={buttonStyle}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      <button
                        onClick={() => handleSave(item.class, item.section)}
                        title="Save"
                        style={buttonStyle}
                      >
                        <FontAwesomeIcon icon={faSave} />
                      </button>
                      <button
                        onClick={() => downloadAs("print", item.class, item.section)}
                        title="Print"
                        style={buttonStyle}
                      >
                        <FontAwesomeIcon icon={faPrint} />
                      </button>
                      <div style={{ position: "relative" }}>
                        <button
                          onClick={() => handleDownload(index)}
                          title="Download"
                          style={buttonStyle}
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </button>
                        {openDropdownIndex === index && (
                          <div
                            style={{
                              position: "absolute",
                              top: "40px",
                              right: 0,
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              zIndex: 1000,
                            }}
                          >
                            <div
                              onClick={() => downloadAs("excel", item.class, item.section)}
                              style={dropdownItemStyle}
                            >
                              Excel
                            </div>
                            <div
                              onClick={() => downloadAs("word", item.class, item.section)}
                              style={dropdownItemStyle}
                            >
                              Word
                            </div>
                            <div
                              onClick={() => downloadAs("pdf", item.class, item.section)}
                              style={{ ...dropdownItemStyle, borderBottom: "none" }}
                            >
                              PDF
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", fontSize: "12px" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MainReport;